import Paper from '@material-ui/core/Paper';

function PaperComponent(props) {
  return <Paper {...props} elevation={0} />;
}

export default PaperComponent;
